"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInitialValue = exports.toggleVisibleFrame = exports.setInputFieldValue = exports.setSelectFieldValue = void 0;
const typesafe_actions_1 = require("typesafe-actions");
const consts_1 = require("./consts");
exports.setSelectFieldValue = (0, typesafe_actions_1.createAction)(consts_1.SET_SELECT_FIELD_VALUE)();
exports.setInputFieldValue = (0, typesafe_actions_1.createAction)(consts_1.SET_INPUT_FIELD_VALUE)();
exports.toggleVisibleFrame = (0, typesafe_actions_1.createAction)(consts_1.TOGGLE_VISIBLE_FRAME)();
exports.setInitialValue = (0, typesafe_actions_1.createAction)(consts_1.SET_INITIAL_VALUES)();
